import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResponseTranslation } from '../models/translation/Translations';

type LocalizedField = Record<string, string>;

type LocalizedValue = LocalizedField | ResponseTranslation;

@Pipe({
  name: 'localized',
  standalone: true,
  pure: false,
})
export class TranslateLocalizedPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: LocalizedValue | null | undefined): string {
    if (!value) return '';
    const lang = this.translateService.currentLang || this.translateService.getDefaultLang();

    const localizedObj = value as Record<string, string>;
    return localizedObj[lang] || localizedObj['en'] || '';
  }
}
